import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/radiochecked.png'
import _imports_1 from '@/assets/icon/radionotchecked.png'


const _withScopeId = n => (_pushScopeId("data-v-4e3dfa8d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "title-contents" }
const _hoisted_3 = { class: "heaer-address" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/" }, "首页", -1))
const _hoisted_5 = { class: "box-contents" }
const _hoisted_6 = { class: "text box-left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "售后服务", -1))
const _hoisted_8 = { class: "type" }
const _hoisted_9 = {
  key: 0,
  class: "pulllist"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pulllist-h2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "服务类型"),
  /*#__PURE__*/_createElementVNode("p", null, "*")
], -1))
const _hoisted_11 = { class: "pulllist-line" }
const _hoisted_12 = {
  key: 0,
  src: _imports_0
}
const _hoisted_13 = {
  key: 1,
  src: _imports_1
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "仅退款(无需退货)", -1))
const _hoisted_15 = {
  key: 0,
  src: _imports_0
}
const _hoisted_16 = {
  key: 1,
  src: _imports_1
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退货退款", -1))
const _hoisted_18 = {
  key: 1,
  class: "pulllist"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "pulllist-h2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "货物状态"),
  /*#__PURE__*/_createElementVNode("p", null, "*")
], -1))
const _hoisted_20 = { class: "pulllist-line" }
const _hoisted_21 = {
  key: 0,
  src: _imports_0
}
const _hoisted_22 = {
  key: 1,
  src: _imports_1
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "未收到货", -1))
const _hoisted_24 = {
  key: 0,
  src: _imports_0
}
const _hoisted_25 = {
  key: 1,
  src: _imports_1
}
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已收到货", -1))
const _hoisted_27 = { class: "pulllist" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("div", null, "退款原因"),
  /*#__PURE__*/_createElementVNode("p", null, "*")
], -1))
const _hoisted_29 = { class: "pulllist" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("div", null, "退款金额"),
  /*#__PURE__*/_createElementVNode("p", null, "*")
], -1))
const _hoisted_31 = { class: "pulllist suggest" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("div", null, "退款说明"),
  /*#__PURE__*/_createElementVNode("p", null, "*")
], -1))
const _hoisted_33 = { class: "pulllist suggest" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("div", null, "上传图片")
], -1))
const _hoisted_35 = { class: "img-list" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao1" }, null, -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "max" }, " 最多上传5张，只能上传jpg/png文件，且不超过5M ", -1))
const _hoisted_38 = { class: "box-right" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "退款/退货商品", -1))
const _hoisted_40 = { class: "add-goods" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon iconfont icon-jiahao-" }, null, -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "同订单商品批量退", -1))
const _hoisted_43 = [
  _hoisted_41,
  _hoisted_42
]

import { ref, reactive, getCurrentInstance, onMounted, nextTick } from "vue"
import type { FormInstance, FormRules } from "element-plus"
import HtmlFooter from "@/components/HtmlFooter.vue"
import HomeHead from "@/components/HomeHead.vue"
import { orderApi, userApi } from "@/service/api"
import type { UploadProps, UploadUserFile } from "element-plus"
import { sjyAlert } from "@/utils/alert"
import CurrentAddress from "@/components/common/CurrentAddress.vue"
import PostSaleGoods from "@/components/order/PostSaleGoods.vue"
import { BasePostSaleType, PostSale, picType } from "@/utils/apitype/goodsType"
import { useRoute, useRouter } from "vue-router"


export default /*#__PURE__*/_defineComponent({
  __name: 'PostSale',
  setup(__props) {

const { proxy } = getCurrentInstance() as any

const postSale: BasePostSaleType = reactive({
  id: 0,
  pid: "",
  reason_id: "",
  reason: "",
  money: "",
  explain: "",
  sales_type: 0,
  pics: [],
  goods_status: 1,
  service_type: 1,
  asid: 0,
})

const params = useRoute()

let orderId = parseInt(params.params.orderid as string)
let goodsId = parseInt(params.params.goodsid as string)
let orderNo = params.params.orderno as string

let selectMoreGoods = (res: any) => {
  console.log(res, "res1")

  PostSaleInfo.list = res

  getSelectPostSale()
}

let pulllistGoodsType = (status: number) => {
  postSale.goods_status = status
  postSale.reason_id = 1
  getClassList()
}
let pulllistServiceType = (status: number) => {
  postSale.reason_id = 1
  postSale.service_type = status
  getClassList()
}

let getClassList = () => {
  if (postSale.goods_status == 2) {
    getClass("shipped")
  } else if (postSale.service_type == 1) {
    getClass("shippednotgoods")
  } else {
    getClass("shipped")
  }
}

let getClass = (classNmae: string = "unshipped") => {
  orderApi.getPostSaleClass(classNmae).then((res: any) => {
    postSaleClass.data = res
    if (postSale.reason_id as number < 1) {
      postSale.reason = postSaleClass.data[0].text
    } else {
      postSale.reason =
        postSaleClass.data[(postSale.reason_id as number) - 1].text
    }
  })
}

let addGoods = () => {
  nextTick(() => {
    proxy.$PostDialog.show({
      goodsList: PostSaleInfo.list,
      onConfirm: () => {},
      onCancel: (res: any) => {
        //console.log(res, "res2")
        if (res != undefined) {
          selectMoreGoods(res)
        }
      },
    })
  })
}

let beforeUpload: UploadProps["beforeUpload"] = (rawFile: any) => {
  if (postSale.pics.length > 5) {
    sjyAlert("最多上传5张图片", "error")
  }
  if (rawFile.type !== "image/jpeg" && rawFile.type !== "image/png") {
    sjyAlert("请上传正确的图片格式", "error")
    return false
  } else if (rawFile.size / 1024 / 1024 > 5) {
    sjyAlert("图片单张大小不能超过5M", "error")
    return false
  }
  //获取上传的签名
  // console.log("开始了", rawFile, "结束了");
  userApi.getOSSToken().then((res: any) => {
    let url = res.data.host
    let new_multipart_params = {
      // key表示上传到Bucket内的Object的完整路径，例如exampledir/exampleobject.txtObject，完整路径中不能包含Bucket名称。
      // filename表示待上传的本地文件名称。
      key: res.data.dir + rawFile.uid + rawFile.name,
      policy: res.data.policy,
      OSSAccessKeyId: res.data.accessid,
      // 设置服务端返回状态码为200，不设置则默认返回状态码204。
      success_action_status: "200",
      signature: res.data.signature,
      file: rawFile,
    }

    userApi.updateOss(url, new_multipart_params).then((res: any) => {
      //console.log("返回信息",res,"返回信息结束")
      if (postSale.pics.length > 5) {
        sjyAlert("最多上传5张图片", "error")
      } else {
        postSale.pics.push({
          name: rawFile.uid + rawFile.name,
          url:
            "https://image.sjyuan.net.cn/img/sjy/" + rawFile.uid + rawFile.name,
        })
      }
    })
  })
  return false
}

const validatePass = (rule: any, value: any, callback: any) => {
  //是数字， 大于0
  if (isNaN(Number(value))) {
    callback(new Error("只能是数字"))
  } else if (Number(value) < 0) {
    callback(new Error("不能小于0"))
  } else {
    callback()
  }
}

const dialogImageUrl = ref("")
const imgdialogVisible = ref(false)

const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!
  imgdialogVisible.value = true
}
let router = useRouter()
let submitlock = ref(false)
const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl || !submitlock) return
  submitlock.value = true
  await formEl.validate((valid, fields) => {
    if (valid) {
      postSale.id = orderId
      postSale.pid = goodsIds.value
      postSale.reason =
        postSaleClass.data[(postSale.reason_id as number) - 1].text
      postSale.sales_type = PostSaleInfo.send_status > 1 ? 2 : 1
      orderApi.addPostSale(postSale).then((res: any) => {
        if (res.errno == 0) {
          sjyAlert("提交成功", "success", () => {
            router.replace({
              name: "postsalestatus",
              params: {
                orderid: orderId,
                goodsid: goodsId,
                orderno: orderNo,
              },
            })
          })
        }
      })
    } else {
    }
  })
}

// 表单验证
const ruleFormRef = ref<FormInstance>()
const rules = reactive<FormRules>({
  reason_id: [
    {
      required: true,
      message: "请选择退款原因",
      trigger: "change",
    },
  ],

  money: [{ validator: validatePass, trigger: "blur" }],
  explain: [
    { required: true, message: "请输入您的退款原因", trigger: "blur" },
    { min: 15, message: "退款原因最少15个字哦", trigger: "blur" },
  ],
})

let postSaleClass = reactive<any>({ data: {} })

let PostSaleInfo = reactive(new PostSale())
//获取订单信息
let getPostSale = () => {
  //todo  接口没有判断订单类型的参数
  orderApi.getPostSale(orderId).then((res: any) => {
    if (res.errno == 0) {
      PostSaleInfo.list = res.datas.list
      PostSaleInfo.price = res.datas.price
      for (let i = 0; i < PostSaleInfo.list.length; i++) {
        if (parseInt(PostSaleInfo.list[i].id) == goodsId) {
          PostSaleInfo.list[i].isSelect = true
        } else {
          PostSaleInfo.list[i].isSelect = false
        }
      }
      PostSaleInfo.price = res.datas.price
      PostSaleInfo.send_status = res.datas.send_status
      getPostInfo()
    }
  })
}
let goodsIds = ref("")
let isShowGoodsList = ref(false)
//获取选中的商品
let getSelectPostSale = () => {
  isShowGoodsList.value = false
  goodsIds.value = ""
  PostSaleInfo.selectlist = []
  for (let i = 0; i < PostSaleInfo.list.length; i++) {
    if (PostSaleInfo.list[i].isSelect) {
      PostSaleInfo.selectlist.push(PostSaleInfo.list[i])
      if (goodsIds.value != "") {
        goodsIds.value += "," + PostSaleInfo.list[i].id
      } else {
        goodsIds.value += PostSaleInfo.list[i].id
      }
    }
  }
  nextTick(() => {
    isShowGoodsList.value = true
  })
  //console.log(PostSaleInfo.selectlist, "selectlist")
}

let getPostInfo = () => {
  orderApi.getPostSaleInfo(orderId, orderNo, goodsId).then((res: any) => {
    if (res.errno == 0 && res.datas.goodsList.length > 0) {
      postSale.asid = res.datas.id
      postSale.id = res.datas.oid
      postSale.pid = res.datas.pid
      let postSaleGoodsList = postSale.pid.split(",")
      for (let i = 0; i < postSaleGoodsList.length; i++) {
        for (let j = 0; j < PostSaleInfo.list.length; j++) {
          if (PostSaleInfo.list[j].id == postSaleGoodsList[i]) {
            PostSaleInfo.list[j].isSelect = true
          }
        }
      }

      postSale.reason_id = parseInt(res.datas.reason_id)
      //postSale.reason = res.datas.reason
      postSale.money = res.datas.money
      postSale.explain = res.datas.explain
      postSale.sales_type = res.datas.sales_type
      if (res.datas.pics != "" && res.datas.pics) {
        // name: rawFile.uid + rawFile.name,
        //   url:
        //     "https://image.sjyuan.net.cn/img/sjy/" + rawFile.uid + rawFile.name,
        let pics = res.datas.pics.split(",")
        for (let i = 0; i < pics.length; i++) {
          let addpics: picType = {
            name: i + ".jpg",
            url: pics[i],
          }
          postSale.pics.push(addpics)
        }
      }
      postSale.goods_status = res.datas.goods_status
      postSale.service_type = res.datas.service_type
      getClassList()
    } else {
      getClassList()
    }
    getSelectPostSale()
  })
}

onMounted(() => {
  getPostSale()
  //getPostInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(HomeHead),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(CurrentAddress, null, {
          address: _withCtx(() => [
            _hoisted_4,
            _createTextVNode(" > 售后服务")
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_el_form, {
            model: postSale,
            rules: rules,
            ref_key: "ruleFormRef",
            ref: ruleFormRef
          }, {
            default: _withCtx(() => [
              (_unref(PostSaleInfo).send_status > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _hoisted_10,
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        class: "pulllist-span",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(pulllistGoodsType)(1)))
                      }, [
                        (postSale.goods_status == 1)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                          : (_openBlock(), _createElementBlock("img", _hoisted_13)),
                        _hoisted_14
                      ]),
                      _createElementVNode("div", {
                        class: "pulllist-span",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(pulllistGoodsType)(2)))
                      }, [
                        (postSale.goods_status == 2)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_15))
                          : (_openBlock(), _createElementBlock("img", _hoisted_16)),
                        _hoisted_17
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_unref(PostSaleInfo).send_status > 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", {
                        class: "pulllist-span",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(pulllistServiceType)(1)))
                      }, [
                        (postSale.service_type == 1)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                          : (_openBlock(), _createElementBlock("img", _hoisted_22)),
                        _hoisted_23
                      ]),
                      _createElementVNode("div", {
                        class: "pulllist-span",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(pulllistServiceType)(2)))
                      }, [
                        (postSale.service_type == 2)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                          : (_openBlock(), _createElementBlock("img", _hoisted_25)),
                        _hoisted_26
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createVNode(_component_el_form_item, { prop: "reason_id" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      placeholder: "退款原因",
                      class: "job",
                      modelValue: postSale.reason_id,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((postSale.reason_id) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postSaleClass).data, (saleclass, index) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            label: saleclass.text,
                            value: saleclass.id
                          }, null, 8, ["label", "value"]))
                        }), 256))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_el_form_item, { prop: "money" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input_number, {
                      modelValue: postSale.money,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((postSale.money) = $event)),
                      min: 0,
                      max: _unref(PostSaleInfo).price,
                      controls: false,
                      placeholder: '最多退款金额￥' + _unref(PostSaleInfo).price
                    }, null, 8, ["modelValue", "max", "placeholder"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_el_form_item, { prop: "explain" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: postSale.explain,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((postSale.explain) = $event)),
                      modelModifiers: { trim: true },
                      rows: 3,
                      type: "textarea",
                      placeholder: "请输入退款原因 (不少于15字)"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_33, [
                _hoisted_34,
                _createElementVNode("div", _hoisted_35, [
                  _createVNode(_component_el_form_item, { prop: "mobile" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        "file-list": postSale.pics,
                        "onUpdate:fileList": _cache[7] || (_cache[7] = ($event: any) => ((postSale.pics) = $event)),
                        action: "",
                        multiple: "",
                        "list-type": "picture-card",
                        limit: "5",
                        "on-preview": handlePictureCardPreview,
                        class: _normalizeClass({ nonejiahao: postSale.pics.length >= 5 }),
                        "before-upload": _unref(beforeUpload)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_36
                        ]),
                        _: 1
                      }, 8, ["file-list", "class", "before-upload"])
                    ]),
                    _: 1
                  }),
                  _hoisted_37
                ])
              ]),
              _createVNode(_component_el_button, {
                round: "",
                class: "routine",
                onClick: _cache[8] || (_cache[8] = ($event: any) => (submitForm(ruleFormRef.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("提交")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])
        ])
      ]),
      _createElementVNode("div", _hoisted_38, [
        _hoisted_39,
        (_unref(PostSaleInfo).selectlist.length > 0 && _unref(isShowGoodsList))
          ? (_openBlock(), _createBlock(PostSaleGoods, {
              key: 0,
              "goods-list": _unref(PostSaleInfo).selectlist
            }, null, 8, ["goods-list"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_40, [
          _createElementVNode("div", {
            class: "add-goods-button",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(addGoods)()))
          }, _hoisted_43)
        ])
      ])
    ]),
    _createVNode(HtmlFooter)
  ]))
}
}

})